(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6643,2576,6818,9600],{

/***/ 62034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(65067),
    isFlattenable = __webpack_require__(95882);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 93401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(24303),
    isArrayLike = __webpack_require__(67878);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 23813:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(50343),
    baseGet = __webpack_require__(13324),
    baseIteratee = __webpack_require__(68286),
    baseMap = __webpack_require__(93401),
    baseSortBy = __webpack_require__(27095),
    baseUnary = __webpack_require__(47826),
    compareMultiple = __webpack_require__(18477),
    identity = __webpack_require__(23059),
    isArray = __webpack_require__(86152);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 27095:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 27520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4795);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 18477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(27520);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 95882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(62034),
    baseOrderBy = __webpack_require__(23813),
    baseRest = __webpack_require__(36060),
    isIterateeCall = __webpack_require__(82406);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 79254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useKey.js + 1 modules
var useKey = __webpack_require__(2095);
// EXTERNAL MODULE: ../../node_modules/typesafe-actions/dist/typesafe-actions.umd.production.js
var typesafe_actions_umd_production = __webpack_require__(32145);
;// CONCATENATED MODULE: ../../libs/matcha/components/Lightbox/useLightbox.ts


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var OPEN = "OPEN";
var CLOSE = "CLOSE";
var NEXT = "NEXT";
var PREVIOUS = "PREVIOUS";

var _open = (0,typesafe_actions_umd_production.createAction)(OPEN)();

var _close = (0,typesafe_actions_umd_production.createAction)(CLOSE)();

var _next = (0,typesafe_actions_umd_production.createAction)(NEXT)();

var _previous = (0,typesafe_actions_umd_production.createAction)(PREVIOUS)();

var reducer = function reducer(state, action) {
  switch (action.type) {
    case OPEN:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          active: action.payload.active,
          opened: true
        });
      }

    case CLOSE:
      {
        if (state.opened) {
          return _objectSpread(_objectSpread({}, state), {}, {
            active: state.active,
            opened: false
          });
        }

        return _objectSpread({}, state);
      }

    case NEXT:
      {
        if (state.opened && state.images.length - 1 > state.active) {
          return _objectSpread(_objectSpread({}, state), {}, {
            active: state.active + 1,
            opened: true
          });
        }

        return _objectSpread({}, state);
      }

    case PREVIOUS:
      {
        if (state.opened && state.active > 0) {
          return _objectSpread(_objectSpread({}, state), {}, {
            active: state.active - 1,
            opened: true
          });
        }

        return _objectSpread({}, state);
      }

    default:
      {
        return _objectSpread({}, state);
      }
  }
};

var DEFAULT_OPTIONS = {
  initialOpen: false,
  images: [],
  active: 0
};

var useLightbox = function useLightbox(options) {
  var settings = (0,react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  }, [options]);

  var _useReducer = (0,react.useReducer)(reducer, {
    active: settings.active,
    opened: settings.initialOpen,
    images: settings.images
  }),
      state = _useReducer[0],
      event = _useReducer[1];

  var active = state.active,
      opened = state.opened;
  (0,useKey/* default */.Z)("Escape", function (e) {
    e.preventDefault();
    event(_close());
  }, undefined, [opened]);
  (0,useKey/* default */.Z)("ArrowRight", function (e) {
    e.preventDefault();
    event(_next());
  }, undefined, [opened, settings.images, active]);
  (0,useKey/* default */.Z)("ArrowLeft", function (e) {
    e.preventDefault();
    event(_previous());
  }, undefined, [opened, active]);
  return {
    opened: opened,
    open: function open(position) {
      event(_open({
        active: position
      }));
    },
    close: function close() {
      event(_close());
    },
    previous: function previous() {
      event(_previous());
    },
    next: function next() {
      event(_next());
    },
    images: settings.images,
    active: active
  };
};

/* harmony default export */ var Lightbox_useLightbox = (useLightbox);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/components/Lightbox/Lightbox.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Images = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "ewy68i710"
} : 0)( true ? {
  name: "1t159it",
  styles: "position:relative;height:100%;display:flex;justify-content:center;align-items:center"
} : 0);
var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewy68i79"
} : 0)( true ? {
  name: "5cnl2k",
  styles: "position:fixed;top:0;left:0;right:0;bottom:0;z-index:1000;overflow:hidden;display:flex;align-items:center"
} : 0);
var CaptionContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewy68i78"
} : 0)("max-width:732px;width:100%;position:absolute;left:50%;transform:translateX(-50%);bottom:56px;padding:0 16px;text-align:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{height:48px;}" + ( true ? "" : 0));
var Caption = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "ewy68i77"
} : 0)(function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.textRegularSmall;
}, ";line-height:calc(20 / 14);width:100%;" + ( true ? "" : 0));

var _ref =  true ? {
  name: "zrl602",
  styles: "left:8px"
} : 0;

var _ref2 =  true ? {
  name: "1n66a4u",
  styles: "right:8px"
} : 0;

var Arrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewy68i76"
} : 0)("display:flex;cursor:pointer;position:absolute;padding:4px 8px;z-index:1;top:calc(50% - 67px);transform:translateY(50%);", function (_ref5) {
  var right = _ref5.right;
  return right ? _ref2 : _ref;
}, ";" + ( true ? "" : 0));
var Media = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.img,  true ? {
  target: "ewy68i75"
} : 0)( true ? {
  name: "1a12p74",
  styles: "pointer-events:none;max-width:100%;max-height:100%"
} : 0);
var MediaArea = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "ewy68i74"
} : 0)("padding:56px 0 128px;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{padding:56px 56px 128px;}position:absolute;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center;" + ( true ? "" : 0));
var Counter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewy68i73"
} : 0)(function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.pSmall;
}, ";position:absolute;top:16px;left:16px;z-index:1;" + ( true ? "" : 0));
var Close = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ewy68i72"
} : 0)( true ? {
  name: "1c4o0gb",
  styles: "cursor:pointer;position:absolute;top:16px;right:16px;z-index:1"
} : 0);
var Dimmer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewy68i71"
} : 0)( true ? {
  name: "te4ze2",
  styles: "position:fixed;top:0;left:0;right:0;bottom:0;z-index:1000"
} : 0);
var Lightbox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewy68i70"
} : 0)(Dimmer, "{background:", function (_ref8) {
  var dimmerBackground = _ref8.dimmerBackground;
  return dimmerBackground;
}, ";}", Counter, "{color:", function (_ref9) {
  var counterColor = _ref9.counterColor;
  return counterColor;
}, ";}", Caption, "{color:", function (_ref10) {
  var captionColor = _ref10.captionColor;
  return captionColor;
}, ";}", Arrow, "{", function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.down("lg");
}, "{background:", function (_ref12) {
  var arrowBackground = _ref12.arrowBackground;
  return arrowBackground;
}, ";}}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Lightbox/Lightbox.tsx


var _excluded = ["active", "images", "close", "previous", "next", "tokens"];

function Lightbox_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Lightbox_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Lightbox_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Lightbox_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}











var animationState = {
  initial: {
    position: "relative",
    opacity: 0
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.75
    }
  },
  exit: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }
};
var SWIPE_CONFIDENCE_THRESHOLD = 10000;

var swipePower = function swipePower(offset, velocity) {
  return Math.abs(offset) * velocity;
};

var BaseLightbox = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var active = _ref.active,
      images = _ref.images,
      close = _ref.close,
      previous = _ref.previous,
      next = _ref.next,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Lightbox, Lightbox_objectSpread(Lightbox_objectSpread(Lightbox_objectSpread({}, tokens), rest), {}, {
    ref: ref,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dimmer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
      children: [close && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close, {
        onClick: close,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "large",
          color: theme.palette.neutrals.white[100]
        })
      }), images && (images === null || images === void 0 ? void 0 : images.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Counter, {
        children: [active + 1, " / ", images === null || images === void 0 ? void 0 : images.length]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MediaArea, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
          initial: false,
          children: images && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Images, {
            drag: "x",
            dragConstraints: {
              left: 0,
              right: 0
            },
            dragMomentum: false,
            onDragEnd: function onDragEnd(_e, _ref2) {
              var offset = _ref2.offset,
                  velocity = _ref2.velocity;
              var swipe = swipePower(offset.x, velocity.x);

              if (swipe < -SWIPE_CONFIDENCE_THRESHOLD && next) {
                next();
              } else if (swipe > SWIPE_CONFIDENCE_THRESHOLD && previous) {
                previous();
              }
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media, Lightbox_objectSpread(Lightbox_objectSpread({}, animationState), {}, {
              src: images[active].src
            }), images[active].src)
          })
        })
      }), images && (images === null || images === void 0 ? void 0 : images.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [active !== 0 && previous && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {
          onClick: previous,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ArrowLeft */.Xd, {
            color: theme.palette.neutrals.white[100],
            size: "medium"
          })
        }), active + 1 !== (images === null || images === void 0 ? void 0 : images.length) && next && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {
          right: true,
          onClick: next,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ArrowRight */.ol, {
            color: theme.palette.neutrals.white[100],
            size: "medium"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CaptionContainer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
          initial: false,
          children: images && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Caption, Lightbox_objectSpread(Lightbox_objectSpread({}, animationState), {}, {
            children: images[active].caption
          }), images[active].src)
        })
      })]
    })]
  }));
});
var Lightbox_Lightbox = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLightbox, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      dimmerBackground: (0,polished_esm/* transparentize */.DZ)(0.1, theme.palette.brand.darkAcai[700]),
      counterColor: theme.palette.neutrals.white[100],
      captionColor: theme.palette.neutrals.white[100],
      arrowBackground: (0,polished_esm/* transparentize */.DZ)(0.5, "#321F46")
    };
  },
  dark: function dark(theme) {
    return {
      dimmerBackground: (0,polished_esm/* transparentize */.DZ)(0.1, theme.palette.brand.darkAcai[700]),
      counterColor: theme.palette.neutrals.white[100],
      captionColor: theme.palette.neutrals.white[100],
      arrowBackground: (0,polished_esm/* transparentize */.DZ)(0.5, "#321F46")
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      dimmerBackground: (0,polished_esm/* transparentize */.DZ)(0.1, theme.palette.twilio.gray[100]),
      counterColor: theme.palette.neutrals.white[100],
      captionColor: theme.palette.neutrals.white[100],
      arrowBackground: (0,polished_esm/* transparentize */.DZ)(0.5, theme.palette.twilio.gray[60])
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Lightbox/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Figure/index.ts + 1 modules
var Figure = __webpack_require__(95976);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../libs/utils/contentfulImageLoader/contentfulImageLoader.ts
var contentfulImageLoader = __webpack_require__(1959);
// EXTERNAL MODULE: ../../libs/utils/usePortal/index.ts
var usePortal = __webpack_require__(47694);
;// CONCATENATED MODULE: ./src/views/Catalog/SinglePage/components/HowItWorks/HowItWorks.tsx



function HowItWorks_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var HowItWorks = function HowItWorks(_ref3) {
  var _integration$integrat, _integration$integrat2;

  var integration = _ref3.integration;
  var hasGallery = Boolean(integration === null || integration === void 0 ? void 0 : (_integration$integrat = integration.integrationScreenshots) === null || _integration$integrat === void 0 ? void 0 : _integration$integrat.length);
  var options = {
    renderNode: (0,defineProperty/* default */.Z)({}, dist.BLOCKS.HEADING_2, function (_, children) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h2",
        children: children
      });
    })
  };
  var withoutSegment = (0,react.useMemo)(function () {
    if (integration !== null && integration !== void 0 && integration.withoutSegment) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
        data: integration === null || integration === void 0 ? void 0 : integration.withoutSegment,
        options: options
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [integration]);
  var items = (integration === null || integration === void 0 ? void 0 : (_integration$integrat2 = integration.integrationScreenshots) === null || _integration$integrat2 === void 0 ? void 0 : _integration$integrat2.map(function (card) {
    var _card$fields, _card$fields$file, _card$fields2, _card$fields2$file, _card$fields3;

    return {
      src: (_card$fields = card.fields) === null || _card$fields === void 0 ? void 0 : (_card$fields$file = _card$fields.file) === null || _card$fields$file === void 0 ? void 0 : _card$fields$file.url,
      imgName: (_card$fields2 = card.fields) === null || _card$fields2 === void 0 ? void 0 : (_card$fields2$file = _card$fields2.file) === null || _card$fields2$file === void 0 ? void 0 : _card$fields2$file.fileName,
      caption: (_card$fields3 = card.fields) === null || _card$fields3 === void 0 ? void 0 : _card$fields3.description
    };
  })) || [];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HowItWorksStyled, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionBaseStyled, {
      variant: "centered",
      copyVariant: "wide",
      hasGallery: hasGallery,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopyStyled, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          children: withoutSegment
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionGridContent, {
        gridSize: items.length,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Gallery, {
          items: items
        })
      })]
    })
  });
};

var Gallery = function Gallery(_ref4) {
  var items = _ref4.items;
  var lightBoxRef = (0,react.useRef)(null);
  var lightboxRoot = (0,usePortal/* default */.Z)("lightbox-root");

  var _useLightbox = Lightbox_useLightbox({
    initialOpen: false,
    images: items
  }),
      opened = _useLightbox.opened,
      active = _useLightbox.active,
      images = _useLightbox.images,
      previous = _useLightbox.previous,
      next = _useLightbox.next,
      close = _useLightbox.close,
      open = _useLightbox.open;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [items && items.map(function (content, idx) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Figure/* default */.ZP, {
        overrides: {
          sm: "horizontal",
          lg: "vertical"
        },
        gridMaxSize: "100%",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Figure/* Image */.Ee, {
          interactive: true,
          loader: contentfulImageLoader/* default */.Z,
          onClick: function onClick() {
            return open(idx);
          },
          alt: content.caption,
          height: 257,
          width: 450,
          src: content.src,
          loading: "lazy"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Figure/* Caption */.YS, {
          children: content.caption
        })]
      }, content.imgName);
    }) || null, opened && /*#__PURE__*/(0,react_dom.createPortal)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Lightbox_Lightbox, {
      ref: lightBoxRef,
      active: active,
      images: images,
      next: next,
      previous: previous,
      close: close
    }), lightboxRoot)]
  });
};

var HowItWorksStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ei4dzbw4"
} : 0)( true ? "" : 0);

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RichText/* ColoredTypography */.nq,  true ? {
  target: "ei4dzbw3"
} : 0)("text-align:center;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("md");
}, "{margin-bottom:60px;}" + ( true ? "" : 0));

var SectionBaseStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ei4dzbw2"
} : 0)(function (_ref6) {
  var hasGallery = _ref6.hasGallery;
  return !hasGallery && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(Section/* Wrapper */.im, "{row-gap:0;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var SectionCopyStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ei4dzbw1"
} : 0)( true ? {
  name: "1iryigw",
  styles: "max-width:880px"
} : 0);

var HowItWorks_ref =  true ? {
  name: "1wojih0",
  styles: "max-width:950px"
} : 0;

var HowItWorks_ref2 =  true ? {
  name: "oz49kj",
  styles: "max-width:450px"
} : 0;

var SectionGridContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "ei4dzbw0"
} : 0)("margin:auto;display:flex;flex-direction:column;gap:32px;align-items:center;max-width:420px;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("sm");
}, "{max-width:100%;}", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("lg");
}, "{display:grid;gap:48px;grid-auto-rows:minmax(100px, auto);max-width:1420px;align-items:start;", function (_ref9) {
  var gridSize = _ref9.gridSize;
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("grid-template-columns:repeat(", gridSize, ", 1fr);" + ( true ? "" : 0),  true ? "" : 0);
}, " ", function (_ref10) {
  var gridSize = _ref10.gridSize;
  return gridSize === 1 ? HowItWorks_ref2 : gridSize === 2 && HowItWorks_ref;
}, ";}" + ( true ? "" : 0));

/* harmony default export */ var HowItWorks_HowItWorks = (HowItWorks);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ./src/views/Catalog/components/IntegrationCard/IntegrationCard.tsx
var IntegrationCard = __webpack_require__(40620);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/Catalog/SinglePage/components/SimilarIntegrations/SimilarIntegrations.tsx


function SimilarIntegrations_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var copy = {
  heading: "Similar integrations"
};
var SimilarIntegrations_link = {
  text: "View all integrations",
  url: "/catalog/"
};

var SimilarIntegrations = function SimilarIntegrations(_ref) {
  var entries = _ref.entries;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimilarIntegrations_Heading, {
      variant: "h2",
      tag: "h2",
      children: copy.heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardsGrid, {
      maxItems: entries.length,
      children: entries === null || entries === void 0 ? void 0 : entries.map(function (integration) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntegrationCard/* default */.Z, {
          integration: integration
        }, integration.objectID);
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: (0,getAbsoluteUrl/* default */.Z)(SimilarIntegrations_link.url, pageConfig),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
        variant: "primary",
        size: "medium",
        tag: "span",
        iconEnd: Common/* ChevronRightIcon */.XC,
        children: SimilarIntegrations_link.text
      })
    })]
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "eg13xk92"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";padding:56px 24px 0;display:grid;justify-items:center;gap:32px;grid-template-columns:1fr;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 0 0;gap:56px;justify-items:center;grid-template-columns:unset;}" + ( true ? "" : 0));

var StyledCardsGrid = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eg13xk91"
} : 0)("display:grid;gap:32px;", function (_ref4) {
  var theme = _ref4.theme,
      maxItems = _ref4.maxItems;
  return maxItems > 1 && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.up("sm"), "{justify-content:center;grid-template-columns:repeat(2, 220px);}" + ( true ? "" : 0),  true ? "" : 0);
}, " ", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xl");
}, "{grid-auto-flow:column;grid-auto-columns:220px;}" + ( true ? "" : 0));

var SimilarIntegrations_Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "eg13xk90"
} : 0)( true ? {
  name: "17vc17s",
  styles: "text-align:center;margin:0"
} : 0);

/* harmony default export */ var SimilarIntegrations_SimilarIntegrations = (SimilarIntegrations);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/matcha/components/LogoTile/index.ts + 2 modules
var LogoTile = __webpack_require__(8831);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
;// CONCATENATED MODULE: ./src/views/Catalog/SinglePage/components/Hero/Hero.tsx



var _renderNode;

function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
























var options = {
  renderNode: (_renderNode = {}, (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.UL_LIST, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        gap: "small",
        tag: "ul",
        children: children
      })
    });
  }), (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.LIST_ITEM, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledFeatureBox, {
      tag: "li",
      alignment: "left",
      headerPosition: "left",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
          background: "white",
          elevation: 1,
          variant: "circle",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CheckIcon */.nQ, {
            color: Theme/* default.palette.twilio.gray.100 */.ZP.palette.twilio.gray[100]
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Body */.uT, {
        children: children
      })]
    });
  }), _renderNode)
};

var createBadge = function createBadge(category, pageConfig) {
  if (!category.fields.name || !category.fields.url) {
    return;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: (0,getAbsoluteUrl/* default */.Z)("/catalog/".concat(category.fields.url, "#grid"), pageConfig),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBadge, {
      tag: "span",
      variant: "outlined",
      children: category.fields.name
    })
  }, category.fields.name);
};

var IntegrationHero = function IntegrationHero(_ref) {
  var integration = _ref.integration,
      className = _ref.className;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var featuresList = (0,react.useMemo)(function () {
    if (!integration.features) {
      return;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
      data: integration.features,
      options: options
    });
  }, [integration.features]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/catalog", pageConfig),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          tag: "span",
          size: "medium",
          iconStart: Common/* ChevronLeftIcon */.wy,
          children: "All integrations"
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroWrapper, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHero, {
        className: className,
        variant: "2Col",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeList, {
          columns: integration.category.length,
          children: integration.category.map(function (category) {
            return createBadge(category, pageConfig);
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroTitle, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h1",
            children: integration.name
          })
        }), integration.introduction && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroIntro, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pExtraLarge",
            tag: "p",
            children: integration.introduction
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroCopy, {
          children: [featuresList, (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonList, {
            children: [integration.website && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* default */.Z, {
              color: "primary",
              variant: "outlined",
              size: "medium",
              tag: "a",
              href: integration.website,
              target: "_blank",
              children: [integration.name, " website"]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
              href: integration.docsUrl,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                color: "primary",
                variant: "outlined",
                size: "medium",
                tag: "span",
                children: "Documentation"
              })
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImage, {
          children: integration.logo && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLogoTile, {
            size: "fill",
            variant: "solid",
            elevation: 1,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
              loader: contentfulImageLoader/* default */.Z,
              src: integration.logo.fields.file.url,
              alt: integration.name,
              width: 160,
              height: 160,
              priority: true
            })
          })
        })]
      })
    })]
  });
};

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqbcvas13"
} : 0)("padding-top:70px;background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var HeroWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eqbcvas12"
} : 0)(Section/* Wrapper */.im, "{padding-top:32px;padding-bottom:32px;}" + ( true ? "" : 0));

var LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqbcvas11"
} : 0)("max-width:1440px;padding:0 24px;margin:0 auto;", Theme/* default.breakpoints.up */.ZP.breakpoints.up("sm"), "{padding:0 40px;}", Theme/* default.breakpoints.up */.ZP.breakpoints.up("lg"), "{padding:0 80px;}" + ( true ? "" : 0));

var StyledHero = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* default */.ZP,  true ? {
  target: "eqbcvas10"
} : 0)("position:relative;padding-bottom:60px;", Hero/* Wrapper */.im, "{align-items:start;gap:0 24px;grid-template-areas:'badges badges' 'title image' 'intro intro' 'copy copy';grid-template-columns:auto 1fr;padding:0;", Theme/* default.breakpoints.up */.ZP.breakpoints.up("md"), "{column-gap:40px;grid-template-areas:'badges badges' 'title image' 'intro image' 'copy copy';}", Theme/* default.breakpoints.up */.ZP.breakpoints.up("lg"), "{grid-template-areas:'badges badges' 'title image' 'intro image' 'copy image';}", Theme/* default.breakpoints.up */.ZP.breakpoints.up("xl"), "{gap:0 160px;}}" + ( true ? "" : 0));

var BadgeList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqbcvas9"
} : 0)( true ? {
  name: "bswbfe",
  styles: "grid-area:badges;margin-bottom:20px;text-align:left"
} : 0);

var StyledBadge = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Badge/* default */.Z,  true ? {
  target: "eqbcvas8"
} : 0)( true ? {
  name: "137pcyc",
  styles: "margin:4px"
} : 0);

var HeroTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "eqbcvas7"
} : 0)("align-self:center;grid-area:title;", Theme/* default.breakpoints.up */.ZP.breakpoints.up("md"), "{margin-bottom:8px;}" + ( true ? "" : 0));

var HeroIntro = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "eqbcvas6"
} : 0)("grid-area:intro;", Theme/* default.breakpoints.down */.ZP.breakpoints.down("sm"), "{margin-top:16px;}" + ( true ? "" : 0));

var HeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Copy */.CK,  true ? {
  target: "eqbcvas5"
} : 0)( true ? "" : 0);

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqbcvas4"
} : 0)( true ? {
  name: "1ckg8iv",
  styles: "margin:56px 0;padding:0"
} : 0);

var StyledFeatureBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "eqbcvas3"
} : 0)( true ? {
  name: "1qvy0a3",
  styles: "p{margin:0;align-self:center;}"
} : 0);

var ButtonList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqbcvas2"
} : 0)("display:grid;gap:24px;margin-top:56px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{grid-template-columns:repeat(2, max-content);}" + ( true ? "" : 0));

var HeroImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Contents */.AU,  true ? {
  target: "eqbcvas1"
} : 0)("display:none;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("sm");
}, "{display:grid;justify-self:flex-end;max-width:100%;width:160px;grid-area:image;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("lg");
}, "{width:240px;}" + ( true ? "" : 0));

var StyledLogoTile = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(LogoTile/* default */.Z,  true ? {
  target: "eqbcvas0"
} : 0)( true ? {
  name: "jptk6q",
  styles: "padding:16%"
} : 0);

/* harmony default export */ var Hero_Hero = (IntegrationHero);
// EXTERNAL MODULE: ../../libs/api/routes/catalog/queries/index.ts + 11 modules
var queries = __webpack_require__(83628);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
;// CONCATENATED MODULE: ./src/views/Catalog/SinglePage/components/LogoTitleBody/LogoTitleBodyImage.tsx










var LogoTitleBodyImage = function LogoTitleBodyImage(_ref) {
  var integration = _ref.integration;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTitleBodyImage_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoImage, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTitleBodyImage_StyledLogoTile, {
        size: "fill",
        elevation: 2,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
          width: "54",
          viewBox: "0 0 54 57",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M51.325 24.833h-27.65a1.942 1.942 0 0 1-1.925-1.925v-3.325c0-1.05.875-1.925 1.925-1.925H51.5c1.05 0 1.925.875 1.925 1.925v3.325c-.175 1.05-1.05 1.925-2.1 1.925ZM30.325 38.833H2.675A1.942 1.942 0 0 1 .75 36.908v-3.325c0-.875.875-1.75 1.925-1.75H30.5c1.05 0 1.925.875 1.925 1.925v3.325c-.175.875-1.05 1.75-2.1 1.75ZM11.25 51.083a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM42.75 12.583a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM27 49.333c-1.925 0-3.85-.35-5.6-.875-.875-.175-1.75.175-2.1 1.05l-1.225 3.325c-.35.875.175 1.925 1.225 2.275 2.45.875 5.075 1.225 7.7 1.225 11.375 0 21.175-6.825 25.55-16.625.35-.875 0-2.1-1.05-2.45l-3.325-1.225c-.875-.35-1.75 0-2.1.875-3.325 7.35-10.5 12.425-19.075 12.425ZM27 7.333c1.925 0 3.85.35 5.6.875.875.175 1.75-.175 2.1-1.05l1.225-3.325c.35-.875-.175-1.925-1.225-2.275C32.25.683 29.625.333 27 .333 15.625.333 5.825 7.158 1.45 16.958c-.35.875 0 2.1 1.05 2.45l3.325 1.225c.875.35 1.75 0 2.1-.875C11.25 12.408 18.425 7.333 27 7.333Z",
            fill: "#25C365"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIcon, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "28",
          height: "29",
          viewBox: "0 0 28 29",
          fill: "none",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "#394762",
            fillRule: "evenodd",
            d: "M11.667 26a2.333 2.333 0 1 0 4.666 0v-9.333h9.334a2.333 2.333 0 0 0 0-4.667h-9.334V2.667a2.333 2.333 0 1 0-4.666 0V12H2.333a2.333 2.333 0 0 0 0 4.667h9.334V26Z",
            clipRule: "evenodd"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTitleBodyImage_StyledLogoTile, {
        size: "fill",
        variant: "solid",
        elevation: 2,
        children: (integration === null || integration === void 0 ? void 0 : integration.logo) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          loader: contentfulImageLoader/* default */.Z,
          src: integration === null || integration === void 0 ? void 0 : integration.logo.fields.file.url,
          alt: integration === null || integration === void 0 ? void 0 : integration.name,
          width: 88,
          height: 88
        })
      })]
    })
  });
};

var LogoTitleBodyImage_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1itdboj3"
} : 0)("margin:0 auto 40px;max-width:400px;position:relative;width:82%;", Theme/* default.breakpoints.up */.ZP.breakpoints.up("sm"), "{margin-bottom:80px;}&::before,&:after{content:'';display:block;width:50.5%;height:100%;position:absolute;top:0;border-radius:16px;border:2px solid transparent;mask-composite:exclude;}&::before{left:0;background:linear-gradient(45deg, #cacdd8 0%, rgba(202, 205, 216, 0) 25%, rgba(202, 205, 216, 0) 75%, #cacdd8 100%) border-box;mask:linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;z-index:1;}&::after{right:0;border-radius:16px;border:2px solid transparent;background:linear-gradient(45deg, rgba(202, 205, 216, 0) 25%, rgba(202, 205, 216, 0) 75%, #cacdd8 100%) border-box;mask:linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;transform:rotate(-180deg);}" + ( true ? "" : 0));

var LogoImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Contents */.AU,  true ? {
  target: "e1itdboj2"
} : 0)("display:flex;align-items:center;margin:0 auto 40px;position:relative;", Theme/* default.breakpoints.up */.ZP.breakpoints.up("sm"), "{margin-bottom:80px;}&:before,&:after{content:'';display:block;width:50.5%;height:100%;background:linear-gradient(135deg, #ffffff 19.39%, rgba(244, 244, 246, 0.5) 59.7%, rgba(244, 244, 246, 0.5) 100%);flex:0 0 auto;border-radius:16px;position:absolute;top:0;}&::before{left:0;}&::after{right:0;transform:rotate(-180deg);}" + ( true ? "" : 0));

var LogoTitleBodyImage_StyledLogoTile = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(LogoTile/* default */.Z,  true ? {
  target: "e1itdboj1"
} : 0)("margin:11%;position:relative;z-index:2;border-radius:16px;border:2px solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[20];
}, ";svg{height:60%;width:60%;}" + ( true ? "" : 0));

var StyledIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1itdboj0"
} : 0)("width:18px;position:absolute;left:50%;transform:translateX(-50%);z-index:1;", Theme/* default.breakpoints.up */.ZP.breakpoints.up("md"), "{width:28px;}" + ( true ? "" : 0));

/* harmony default export */ var LogoTitleBody_LogoTitleBodyImage = (LogoTitleBodyImage);
;// CONCATENATED MODULE: ./src/views/Catalog/SinglePage/components/LogoTitleBody/LogoTitleBody.tsx



var LogoTitleBody_renderNode;

function LogoTitleBody_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var LogoTitleBody_options = {
  renderNode: (LogoTitleBody_renderNode = {}, (0,defineProperty/* default */.Z)(LogoTitleBody_renderNode, dist.BLOCKS.HEADING_2, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTitleBody_Heading, {
      variant: "h2",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(LogoTitleBody_renderNode, dist.BLOCKS.PARAGRAPH, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* ColoredTypography */.nq, {
      variant: "pLarge",
      tag: "p",
      color: Theme/* default.palette.twilio.gray.100 */.ZP.palette.twilio.gray[100],
      children: children
    });
  }), LogoTitleBody_renderNode)
};

var LogoTitleBody = function LogoTitleBody(_ref) {
  var integration = _ref.integration;
  var withSegmentContent = (0,react.useMemo)(function () {
    if (!(integration !== null && integration !== void 0 && integration.withSegment)) {
      return;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
      data: integration === null || integration === void 0 ? void 0 : integration.withSegment,
      options: LogoTitleBody_options
    });
  }, [integration]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTitleBody_SectionBaseStyled, {
    variant: "centered",
    copyVariant: "wide",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTitleBody_SectionCopyStyled, {
      children: (integration === null || integration === void 0 ? void 0 : integration.logo) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTitleBody_LogoTitleBodyImage, {
          integration: integration
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentWrapper, {
          children: withSegmentContent
        })]
      })
    })
  });
};

var LogoTitleBody_SectionCopyStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "emagzqx3"
} : 0)( true ? {
  name: "1iryigw",
  styles: "max-width:880px"
} : 0);

var LogoTitleBody_Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RichText/* ColoredTypography */.nq,  true ? {
  target: "emagzqx2"
} : 0)("text-align:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{margin-bottom:70px;}" + ( true ? "" : 0));

var ContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "emagzqx1"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);

var LogoTitleBody_SectionBaseStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "emagzqx0"
} : 0)(Section/* Wrapper */.im, "{row-gap:0;}" + ( true ? "" : 0));

/* harmony default export */ var LogoTitleBody_LogoTitleBody = (LogoTitleBody);
// EXTERNAL MODULE: ./src/views/Catalog/SinglePage/assets/OgCatalog.png
var OgCatalog = __webpack_require__(64011);
var OgCatalog_default = /*#__PURE__*/__webpack_require__.n(OgCatalog);
;// CONCATENATED MODULE: ./src/views/Catalog/SinglePage/CatalogIntegration.tsx
















var CatalogIntegrationView = function CatalogIntegrationView(_ref) {
  var slug = _ref.slug,
      category = _ref.category,
      random = _ref.random,
      amount = _ref.amount;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useSingleIntegration = (0,queries/* useSingleIntegrationQuery */.aV)({
    args: [slug]
  }),
      data = _useSingleIntegration.data; // If we can't find the integration we really can't render anything


  var _useSimilarIntegratio = (0,queries/* useSimilarIntegrationsQuery */.UF)({
    args: [{
      slug: slug,
      category: category,
      random: random,
      amount: amount
    }]
  }),
      similarIntegrations = _useSimilarIntegratio.data;

  if (!data || !similarIntegrations) return null;
  var name = data === null || data === void 0 ? void 0 : data.name;
  var introduction = data === null || data === void 0 ? void 0 : data.introduction;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "".concat(name, " Integration"),
      pageDescription: "Learn more about ".concat(name, " on Segment. ").concat(name, ": ").concat(introduction),
      pageOG: (OgCatalog_default()),
      bodyBackground: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
          integration: data
        }), (data === null || data === void 0 ? void 0 : data.withoutSegment) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HowItWorks_HowItWorks, {
          integration: data
        }), (data === null || data === void 0 ? void 0 : data.withSegment) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTitleBody_LogoTitleBody, {
          integration: data
        }), Boolean(similarIntegrations === null || similarIntegrations === void 0 ? void 0 : similarIntegrations.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimilarIntegrations_SimilarIntegrations, {
          entries: similarIntegrations
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {
          heading: "Integrate ".concat(name, " with Segment"),
          description: "Segment makes it easy to set up ".concat(name, ".")
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e15swdjy0"
} : 0)( true ? "" : 0);

/* harmony default export */ var CatalogIntegration = (CatalogIntegrationView);
// EXTERNAL MODULE: ../../libs/api/algolia/client.ts
var client = __webpack_require__(2017);
// EXTERNAL MODULE: ../../libs/contexts/catalogIndex.ts
var catalogIndex = __webpack_require__(97946);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/catalog/integrations/[[...slug]].tsx







var Integration = function Integration(_ref) {
  var slug = _ref.slug,
      category = _ref.category,
      random = _ref.random,
      amount = _ref.amount;
  var catalogClient = (0,client/* createClient */.e)();
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(catalogIndex/* CatalogClientProvider */.sR, {
      value: catalogClient,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CatalogIntegration, {
        slug: slug,
        category: category,
        random: random,
        amount: amount
      })
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var _slug_ = (Integration);

/***/ }),

/***/ 40620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97536);
/* harmony import */ var _segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17397);
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43848);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);









var EMPTY_QUERY_MESSAGE = "No search term specified";

var IntegrationCardTemplate = function IntegrationCardTemplate(_ref) {
  var _integration$logo, _integration$logo2, _integration$logo$src, _integration$logo3, _integration$categori, _integration$categori2, _integration$categori3;

  var integration = _ref.integration,
      isInCategoryGrid = _ref.isInCategoryGrid,
      query = _ref.query;
  var pageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)();
  var onClickHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/(0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _integration$slug;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,_segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_3__/* .trackCatalogCardClick */ .tR)({
              searchTerm: query !== null && query !== void 0 ? query : EMPTY_QUERY_MESSAGE,
              catalogItem: integration === null || integration === void 0 ? void 0 : (_integration$slug = integration.slug) === null || _integration$slug === void 0 ? void 0 : _integration$slug.replace(/\//g, "")
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [integration, query]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    href: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("/catalog/integrations/".concat(integration.type).concat(integration.slug), pageConfig),
    onClick: onClickHandler,
    children: [integration.beta && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Badge */ .Ct, {
      children: "Beta"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
      centered: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .LogoWrapper */ .K7, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Logo */ .TR, {
          width: (_integration$logo = integration.logo) === null || _integration$logo === void 0 ? void 0 : _integration$logo.width,
          height: (_integration$logo2 = integration.logo) === null || _integration$logo2 === void 0 ? void 0 : _integration$logo2.height,
          src: (_integration$logo$src = (_integration$logo3 = integration.logo) === null || _integration$logo3 === void 0 ? void 0 : _integration$logo3.src) !== null && _integration$logo$src !== void 0 ? _integration$logo$src : "",
          alt: "integration logo"
        })
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Name */ .VG, {
        children: integration.name
      }), !isInCategoryGrid && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_recipes_IntegrationCard__WEBPACK_IMPORTED_MODULE_2__/* .Description */ .dk, {
        children: (_integration$categori = integration.categories) === null || _integration$categori === void 0 ? void 0 : (_integration$categori2 = _integration$categori[0]) === null || _integration$categori2 === void 0 ? void 0 : (_integration$categori3 = _integration$categori2.category) === null || _integration$categori3 === void 0 ? void 0 : _integration$categori3.name
      })]
    })]
  }, integration.objectID);
};

/* harmony default export */ __webpack_exports__["Z"] = (IntegrationCardTemplate);

/***/ }),

/***/ 83628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yT": function() { return /* reexport */ useGroupedIntegrationsQuery; },
  "B": function() { return /* reexport */ useIntegrationsQuery; },
  "UF": function() { return /* reexport */ useSimilarIntegrationsQuery; },
  "aV": function() { return /* reexport */ useSingleIntegrationQuery; }
});

// UNUSED EXPORTS: attributesToFetch, createAllCategoriesQuery, createAllIntegrationsQuery, createGroupedIntegrationsQuery, createIntegrationsQuery, createNonEmptyCategoriesQuery, createSimilarIntegrationsQuery, createSingleIntegrationQuery, fetchIntegrations, fetchRandomSimilarIntegrations, groupIntegrations, similarIntegrationsAttributesToFetch, useAllCategoriesQuery, useAllIntegrationsQuery, useNonEmptyIntegrationsQuery

// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/catalog.ts

var fetchAllCategories = function fetchAllCategories(client) {
  return client.get("/content/entries/category").then(function (value) {
    return sortBy_default()(value, function (item) {
      return item.name;
    });
  });
};
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/allCategoriesQuery.ts



var createAllCategoriesQuery = function createAllCategoriesQuery(client) {
  return [["catalog/allCategoriesQuery"], function () {
    return fetchAllCategories(client);
  }];
};
var useAllCategoriesQuery = (0,createQueryHook/* default */.Z)(createAllCategoriesQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/integration.ts

var fetchAllIntegrations = function fetchAllIntegrations(client) {
  return client.get("/content/entries/integrations").then(function (value) {
    // If the integration is in Private Beta, we want to filter it out of the response.
    var filteredValue = value.filter(function (value) {
      return !value.privateBeta;
    });
    return sortBy_default()(filteredValue, function (item) {
      return item.name;
    });
  });
};
var fetchIntegration = function fetchIntegration(client, slug) {
  return client.get("/content/entries/integrations?url=".concat(slug)).then(function (value) {
    // If the integration is in Private Beta, we do not want to generate a static page for the integration.
    if (value.privateBeta) {
      return;
    }

    return value;
  });
};
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/allIntegrationsQuery.ts



var createAllIntegrationsQuery = function createAllIntegrationsQuery(client) {
  return [["catalog", "allIntegrationsQuery"], function () {
    return fetchAllIntegrations(client);
  }];
};
var useAllIntegrationsQuery = (0,createQueryHook/* default */.Z)(createAllIntegrationsQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
// EXTERNAL MODULE: ../../libs/contexts/catalogIndex.ts
var contexts_catalogIndex = __webpack_require__(97946);
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/allNonEmptyCategories.ts
/* provided dependency */ var process = __webpack_require__(34406);







var keys = ["catalog", "nonEmptyCategoriesQuery"];
var createNonEmptyCategoriesQuery = function createNonEmptyCategoriesQuery(_ref) {
  var catalogIndex = _ref.catalogIndex,
      staticSiteBackend = _ref.staticSiteBackend;
  return [keys, /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var enabled, algoliaCachedSearch, facetsRequest, categoriesRequest, _yield$facetsRequest, facets, categories, integrationsCountPerCategory, categoriesWithAnyIntegrations;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return (0,fsCache/* createFsCacheProxy */.c)(keys, catalogIndex.search, {
              enabled: enabled
            });

          case 3:
            algoliaCachedSearch = _context.sent;
            facetsRequest = algoliaCachedSearch("", {
              responseFields: ["facets"],
              facets: ["categories.category.slug"],
              maxValuesPerFacet: 1000
            });
            categoriesRequest = fetchAllCategories(staticSiteBackend);
            _context.next = 8;
            return facetsRequest;

          case 8:
            _yield$facetsRequest = _context.sent;
            facets = _yield$facetsRequest.facets;
            _context.next = 12;
            return categoriesRequest;

          case 12:
            categories = _context.sent;
            integrationsCountPerCategory = facets === null || facets === void 0 ? void 0 : facets["categories.category.slug"];
            categoriesWithAnyIntegrations = categories.filter(function (c) {
              return integrationsCountPerCategory && integrationsCountPerCategory[c.url];
            });
            return _context.abrupt("return", categoriesWithAnyIntegrations.map(function (c) {
              return {
                name: c.name,
                slug: c.url
              };
            }));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))];
};
var useNonEmptyIntegrationsQuery = (0,createQueryHook/* default */.Z)(createNonEmptyCategoriesQuery, function () {
  var catalogIndex = (0,contexts_catalogIndex/* useCatalogIndex */.TO)();
  var staticSiteBackend = (0,contexts_staticSiteBackend/* useStaticSiteBackend */.gR)();
  return {
    catalogIndex: catalogIndex,
    staticSiteBackend: staticSiteBackend
  };
}, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/common.ts
/* provided dependency */ var common_process = __webpack_require__(34406);




var attributesToFetch = ["contentType", "slug", "name", "logo", "categories", "type", "beta"];
var DESTINATION_FILTER = "type:destination";
var SOURCE_FILTER = "type:source";
var INTEGRATIONS_CONTENT_TYPE = "contentType:integrations";
var fetchIntegrations = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var query, catalogIndex, pageParam, category, _ref$distinct, distinct, hitsPerPage, source, destination, _ref$categoryNegation, categoryNegation, extFilters, cacheKey, enabled, algoliaCachedSearch, categoryFilters, typeFilters, filters;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, catalogIndex = _ref.catalogIndex, pageParam = _ref.pageParam, category = _ref.category, _ref$distinct = _ref.distinct, distinct = _ref$distinct === void 0 ? 0 : _ref$distinct, hitsPerPage = _ref.hitsPerPage, source = _ref.source, destination = _ref.destination, _ref$categoryNegation = _ref.categoryNegation, categoryNegation = _ref$categoryNegation === void 0 ? false : _ref$categoryNegation, extFilters = _ref.filters, cacheKey = _ref.cacheKey;
            enabled = Boolean(common_process.env.ENABLE_FS_CACHE);
            _context.next = 4;
            return (0,fsCache/* createFsCacheProxy */.c)(["catalog-fetchIntegrations"].concat((0,toConsumableArray/* default */.Z)(cacheKey ? cacheKey : [query, pageParam !== null && pageParam !== void 0 ? pageParam : null, category !== null && category !== void 0 ? category : null, distinct !== null && distinct !== void 0 ? distinct : null, hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : null, source !== null && source !== void 0 ? source : null, destination !== null && destination !== void 0 ? destination : null, categoryNegation !== null && categoryNegation !== void 0 ? categoryNegation : null, extFilters !== null && extFilters !== void 0 ? extFilters : null])), function () {
              return catalogIndex.search.apply(catalogIndex, arguments);
            }, {
              enabled: enabled
            });

          case 4:
            algoliaCachedSearch = _context.sent;
            categoryFilters = typeof category === "string" ? (categoryNegation ? "NOT " : "") + "categories.category.slug:".concat(category) : undefined;
            typeFilters = [];
            if (destination) typeFilters.push(DESTINATION_FILTER);
            if (source) typeFilters.push(SOURCE_FILTER);
            if (!source && !destination) typeFilters.push("NOT ".concat(DESTINATION_FILTER, " AND NOT ").concat(SOURCE_FILTER));
            filters = [categoryFilters, extFilters, "(".concat(typeFilters.join(" OR "), ")"), INTEGRATIONS_CONTENT_TYPE].filter(function (filter) {
              return filter && filter !== "()";
            }).join(" AND ");
            return _context.abrupt("return", algoliaCachedSearch(query, {
              attributesToRetrieve: ["-*"].concat(attributesToFetch),
              distinct: distinct,
              page: pageParam !== null && pageParam !== void 0 ? pageParam : 0,
              hitsPerPage: hitsPerPage,
              filters: filters
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchIntegrations(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/utils.ts
var groupIntegrations = function groupIntegrations(acc, integration) {
  if (integration._distinctSeqID === 0 || integration._distinctSeqID === undefined) {
    var _integration$categori, _integration$categori2;

    var category = (_integration$categori = integration.categories) === null || _integration$categori === void 0 ? void 0 : (_integration$categori2 = _integration$categori[0]) === null || _integration$categori2 === void 0 ? void 0 : _integration$categori2.category;

    if (category && category.name && category.slug) {
      acc.push({
        category: {
          name: category.name,
          slug: category.slug
        },
        integrations: [integration]
      });
    } else {
      acc.push({
        integrations: [integration]
      });
    }
  } else if (acc.length > 0) {
    acc[acc.length - 1].integrations.push(integration);
  } else {
    throw new Error("Invalid algolia response. Hits sequence isn't starting with _distinctSeqID=0");
  }

  return acc;
};
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/groupedIntegrationsQuery.ts



var _excluded = ["hits"];


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var createGroupedIntegrationsQuery = function createGroupedIntegrationsQuery(catalogIndex) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$destination = _ref.destination,
      destination = _ref$destination === void 0 ? true : _ref$destination,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? true : _ref$source;

  return [["catalog", "groupedIntegrationsQuery", destination, source], /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var pageParam, _yield$fetchIntegrati, hits, rest, groups;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pageParam = _ref2.pageParam;
              _context.next = 3;
              return fetchIntegrations({
                catalogIndex: catalogIndex,
                query: "",
                category: null,
                destination: destination,
                pageParam: pageParam,
                source: source,
                distinct: 8,
                hitsPerPage: 4
              });

            case 3:
              _yield$fetchIntegrati = _context.sent;
              hits = _yield$fetchIntegrati.hits;
              rest = (0,objectWithoutProperties/* default */.Z)(_yield$fetchIntegrati, _excluded);
              groups = hits.reduce(groupIntegrations, []);
              return _context.abrupt("return", _objectSpread({
                hits: groups
              }, rest));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()];
};
var useGroupedIntegrationsQuery = (0,createInfinityQueryHook/* default */.Z)(createGroupedIntegrationsQuery, contexts_catalogIndex/* useCatalogIndex */.TO, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    var _p$page;

    var page = (_p$page = p.page) !== null && _p$page !== void 0 ? _p$page : 0;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(p) {
    var _p$page2;

    var page = (_p$page2 = p.page) !== null && _p$page2 !== void 0 ? _p$page2 : 0;
    var nextPage = page + 1;

    if (nextPage >= p.nbPages) {
      return;
    }

    return nextPage;
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/integrationsQuery.ts



var createIntegrationsQuery = function createIntegrationsQuery(_ref, _ref2) {
  var catalogIndex = _ref.catalogIndex,
      catalogSearchIndex = _ref.catalogSearchIndex;
  var query = _ref2.query,
      _ref2$category = _ref2.category,
      category = _ref2$category === void 0 ? null : _ref2$category,
      _ref2$destination = _ref2.destination,
      destination = _ref2$destination === void 0 ? true : _ref2$destination,
      _ref2$source = _ref2.source,
      source = _ref2$source === void 0 ? true : _ref2$source,
      _ref2$categoryNegatio = _ref2.categoryNegation,
      categoryNegation = _ref2$categoryNegatio === void 0 ? false : _ref2$categoryNegatio,
      _ref2$hitsPerPage = _ref2.hitsPerPage,
      hitsPerPage = _ref2$hitsPerPage === void 0 ? 20 : _ref2$hitsPerPage,
      filters = _ref2.filters;
  return [["catalog", "integrationsQuery", query, category, destination, source, categoryNegation, hitsPerPage], function (_ref3) {
    var pageParam = _ref3.pageParam;
    return fetchIntegrations({
      query: query,
      catalogIndex: query === "" ? catalogIndex : catalogSearchIndex,
      category: category,
      destination: destination,
      pageParam: pageParam,
      source: source,
      categoryNegation: categoryNegation,
      hitsPerPage: hitsPerPage,
      filters: filters
    });
  }];
};
var useIntegrationsQuery = (0,createInfinityQueryHook/* default */.Z)(createIntegrationsQuery, function () {
  var catalogIndex = (0,contexts_catalogIndex/* useCatalogAlphaIndex */.jH)();
  var catalogSearchIndex = (0,contexts_catalogIndex/* useCatalogSearchIndex */.Nv)();
  return {
    catalogIndex: catalogIndex,
    catalogSearchIndex: catalogSearchIndex
  };
}, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    var _p$page;

    var page = (_p$page = p.page) !== null && _p$page !== void 0 ? _p$page : 0;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(p) {
    var _p$page2;

    var page = (_p$page2 = p.page) !== null && _p$page2 !== void 0 ? _p$page2 : 0;
    var nextPage = page + 1;

    if (nextPage >= p.nbPages) {
      return;
    }

    return nextPage;
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/singleIntegrationQuery.ts



var createSingleIntegrationQuery = function createSingleIntegrationQuery(client, slug) {
  return [["catalog/singleIntegrationQuery", slug], function () {
    return fetchIntegration(client, slug);
  }];
};
var useSingleIntegrationQuery = (0,createQueryHook/* default */.Z)(createSingleIntegrationQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../libs/utils/deterministicShuffle/deterministicShuffle.ts
var deterministicShuffle = __webpack_require__(575);
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/similarIntegrationsQuery.ts






var similarIntegrationsAttributesToFetch = (/* unused pure expression or super */ null && (["contentType", "slug", "name", "logo", "categories", "type", "beta"]));
var fetchRandomSimilarIntegrations = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var catalogIndex, random, category, slug, data, similarIntegrations;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            catalogIndex = _ref.catalogIndex, random = _ref.random, category = _ref.category, slug = _ref.slug;
            _context.next = 3;
            return fetchIntegrations({
              catalogIndex: catalogIndex,
              query: "",
              distinct: 1,
              category: category,
              hitsPerPage: 20,
              destination: true,
              source: true
            });

          case 3:
            data = _context.sent;
            similarIntegrations = random ? (0,deterministicShuffle/* default */.Z)(data.hits) : data.hits;
            return _context.abrupt("return", similarIntegrations.filter(function (h) {
              return h.slug && normalizeSlug(h.slug) !== slug;
            }).slice(0, 4));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchRandomSimilarIntegrations(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var normalizeSlug = function normalizeSlug(slug) {
  var startOffset = slug.startsWith("/") ? 1 : 0;
  var endOffset = slug.endsWith("/") ? -1 : 0;
  return slug.substring(startOffset, slug.length + endOffset);
};

var createSimilarIntegrationsQuery = function createSimilarIntegrationsQuery(catalogIndex, _ref3) {
  var slug = _ref3.slug,
      category = _ref3.category,
      random = _ref3.random,
      amount = _ref3.amount;
  return [["catalog/SimilarIntegrationsQuery", slug !== null && slug !== void 0 ? slug : null, category !== null && category !== void 0 ? category : null, random !== null && random !== void 0 ? random : null, amount !== null && amount !== void 0 ? amount : null], function () {
    return fetchRandomSimilarIntegrations({
      catalogIndex: catalogIndex,
      random: random,
      slug: slug,
      amount: amount,
      category: category
    });
  }];
};
var useSimilarIntegrationsQuery = (0,createQueryHook/* default */.Z)(createSimilarIntegrationsQuery, contexts_catalogIndex/* useCatalogIndex */.TO, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/catalog/queries/index.ts










/***/ }),

/***/ 86708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": function() { return /* binding */ StaticSiteBackendProvider; },
/* harmony export */   "I4": function() { return /* binding */ createStaticSiteBackend; },
/* harmony export */   "gR": function() { return /* binding */ useStaticSiteBackend; }
/* harmony export */ });
/* unused harmony export StaticSiteBackendContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39896);


var StaticSiteBackendContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var StaticSiteBackendProvider = StaticSiteBackendContext.Provider;
var useStaticSiteBackend = function useStaticSiteBackend() {
  var staticSiteBackend = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StaticSiteBackendContext);

  if (!staticSiteBackend) {
    throw new Error("Static site backend isn't available. Please set it via StaticSiteBackendProvider component.");
  }

  return staticSiteBackend;
}; // Helper method to simplify importing

var createStaticSiteBackend = function createStaticSiteBackend() {
  return (0,_segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .e)();
};

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 79600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_IconWrapper_IconWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bo4d8j1"
} : 0)("width:44px;height:44px;border-radius:50%;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";", function (_ref4) {
  var elevation = _ref4.elevation,
      theme = _ref4.theme;
  return elevation &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:", theme.shadows[elevation], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1iixa1j",
  styles: "width:40px;height:40px;svg{width:40px;height:40px;}padding:2px"
} : 0;

var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1bo4d8j0"
} : 0)("display:block;width:24px;height:24px;padding:10px;", function (_ref5) {
  var variant = _ref5.variant;
  return variant === "transparent" && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.tsx


var _excluded = ["tokens", "variant", "elevation", "className", "tag", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseIconWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      variant = _ref.variant,
      elevation = _ref.elevation,
      className = _ref.className,
      tag = _ref.tag,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: className,
    elevation: elevation,
    as: tag
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      variant: variant,
      children: children
    })
  }));
});

var getBackgroundPropTokens = function getBackgroundPropTokens(background, theme) {
  switch (background) {
    case "white":
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[500]
      };

    case "light":
      return {
        backgroundColor: theme.palette.brand.boysenberry[100],
        color: theme.palette.brand.darkAcai[700]
      };

    case "dark":
      return {
        backgroundColor: theme.palette.brand.darkAcai[600],
        color: theme.palette.brand.boysenberry[200]
      };

    default:
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
  }
};

var IconWrapper_IconWrapper = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIconWrapper, function (_ref2) {
  var elevation = _ref2.elevation;
  return {
    elevation: elevation
  };
}, {
  light: function light(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.brand.darkAcai[700],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.darkAcai[700],
      backgroundColor: theme.palette.brand.boysenberry[100]
    };
  },
  dark: function dark(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.neutrals.white[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.boysenberry[200],
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.twilio.gray[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.twilio.gray[100],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});
/* harmony default export */ var components_IconWrapper_IconWrapper = (IconWrapper_IconWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/index.ts


/***/ }),

/***/ 8831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LogoTile_LogoTile; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(86015);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
;// CONCATENATED MODULE: ../../libs/matcha/components/LogoTile/LogoTile.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var _ref =  true ? {
  name: "1efxxc0",
  styles: "::before{content:'';display:inline-block;width:0;height:0;padding-bottom:100%;}"
} : 0;

var LogoTile = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0,emotion_is_prop_valid_esm/* default */.Z)(prop) && prop !== "size";
  },
  target: "ez67hgk0"
} : 0)("display:flex;justify-content:center;align-items:center;padding:10px;border-radius:10px;border:1px solid transparent;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";width:", function (_ref3) {
  var width = _ref3.width;
  return width;
}, ";height:", function (_ref4) {
  var height = _ref4.height;
  return height;
}, ";", function (_ref5) {
  var width = _ref5.width;
  return width === "100%" && _ref;
}, " background-color:", function (_ref6) {
  var backgroundColor = _ref6.backgroundColor;
  return backgroundColor;
}, ";border-color:", function (_ref7) {
  var borderColor = _ref7.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/LogoTile/LogoTile.tsx


var _excluded = ["elevation", "role", "children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseLogoTile = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      role = _ref.role,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTile, _objectSpread(_objectSpread(_objectSpread({
    elevation: elevation,
    role: role,
    ref: ref
  }, rest), tokens), {}, {
    children: children
  }));
});
var LogoTile_LogoTile = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLogoTile, function (props) {
  return props.size === "fill" ? {
    width: "100%"
  } : {
    width: "".concat(props.size, "px"),
    height: "".concat(props.size, "px")
  };
}, {
  light: function light(theme, _ref2) {
    var _ref2$variant = _ref2.variant,
        variant = _ref2$variant === void 0 ? "transparent" : _ref2$variant;

    switch (variant) {
      case "transparent":
        return {
          backgroundColor: (0,polished_esm/* transparentize */.DZ)(0.94, theme.palette.brand.darkAcai[700])
        };

      case "solid":
        return {
          backgroundColor: theme.palette.neutrals.white[100]
        };

      case "active":
      default:
        return {
          backgroundColor: theme.palette.neutrals.white[100],
          borderColor: theme.palette.brand.boysenberry[500]
        };
    }
  },
  dark: function dark(theme, _ref3) {
    var _ref3$variant = _ref3.variant,
        variant = _ref3$variant === void 0 ? "transparent" : _ref3$variant;

    switch (variant) {
      case "transparent":
        return {
          backgroundColor: (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.neutrals.white[100])
        };

      case "solid":
        return {
          backgroundColor: theme.palette.brand.darkAcai[600]
        };

      case "active":
      default:
        return {
          backgroundColor: theme.palette.brand.boysenberry[500]
        };
    }
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      borderColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/LogoTile/index.ts


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58586);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates infinite query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useInfiniteQuery
 */

var createInfiniteQueryHook = function createInfiniteQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery.apply */ .N.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createInfiniteQueryHook);

/***/ }),

/***/ 74048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58943);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useQuery
 */

var createQueryHook = function createQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery.apply */ .a.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createQueryHook);

/***/ }),

/***/ 575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shuffleWithSeed */
// SOURCE: https://github.com/yixizhang/seed-shuffle

/**
 * This is an util to generate a shuffled array, with deterministic randomness provided by the seed.
 *
 * @param array - The array to be shuffled
 * @param seed - The seed to generate the randomness
 * @returns The shuffled array
 */
var shuffleWithSeed = function shuffleWithSeed(array) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1332712639;
  var currentIndex = array.length;
  var temporaryValue;
  var randomIndex;
  seed = seed || 1;

  var random = function random() {
    var x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  }; // While there remain elements to shuffle...


  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(random() * currentIndex);
    currentIndex -= 1; // And swap it with the current element.

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

var deterministicShuffle = function deterministicShuffle(array, someRandom) {
  return shuffleWithSeed(array, someRandom);
};

/* harmony default export */ __webpack_exports__["Z"] = (deterministicShuffle);

/***/ }),

/***/ 10715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ createFsCacheProxy; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95922);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12741);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* module decorator */ module = __webpack_require__.hmd(module);




function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}



function _asyncIterator(iterable) {
  var method,
      async,
      sync,
      retry = 2;

  for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) {
    if (async && null != (method = iterable[async])) return method.call(iterable);
    if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
    async = "@@asyncIterator", sync = "@@iterator";
  }

  throw new TypeError("Object is not async iterable");
}

function AsyncFromSyncIterator(s) {
  function AsyncFromSyncIteratorContinuation(r) {
    if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
    var done = r.done;
    return Promise.resolve(r.value).then(function (value) {
      return {
        value: value,
        done: done
      };
    });
  }

  return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) {
    this.s = s, this.n = s.next;
  }, AsyncFromSyncIterator.prototype = {
    s: null,
    n: null,
    next: function next() {
      return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
    },
    "return": function _return(value) {
      var ret = this.s["return"];
      return void 0 === ret ? Promise.resolve({
        value: value,
        done: !0
      }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
    },
    "throw": function _throw(value) {
      var thr = this.s["return"];
      return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
    }
  }, new AsyncFromSyncIterator(s);
}

function maybeImport(_x) {
  return _maybeImport.apply(this, arguments);
}

function _maybeImport() {
  _maybeImport = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(importFn) {
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return",  false ? 0 : Promise.resolve(null));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _maybeImport.apply(this, arguments);
}

function getPkgJsonDir() {
  return _getPkgJsonDir.apply(this, arguments);
}

function _getPkgJsonDir() {
  _getPkgJsonDir = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
    var _yield$import, dirname, _yield$import2, constants, access, errors, _iterator3, _step3, path, prospectivePkgJsonDir;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            _yield$import = _context4.sent;
            dirname = _yield$import.dirname;
            _context4.next = 6;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 6:
            _yield$import2 = _context4.sent;
            constants = _yield$import2.constants;
            access = _yield$import2.promises.access;
            errors = [];
            _iterator3 = _createForOfIteratorHelper(module.paths);
            _context4.prev = 11;

            _iterator3.s();

          case 13:
            if ((_step3 = _iterator3.n()).done) {
              _context4.next = 27;
              break;
            }

            path = _step3.value;
            _context4.prev = 15;
            prospectivePkgJsonDir = dirname(path); // eslint-disable-next-line no-await-in-loop

            _context4.next = 19;
            return access(path, constants.F_OK);

          case 19:
            return _context4.abrupt("return", prospectivePkgJsonDir);

          case 22:
            _context4.prev = 22;
            _context4.t0 = _context4["catch"](15);
            errors.push(_context4.t0);

          case 25:
            _context4.next = 13;
            break;

          case 27:
            _context4.next = 32;
            break;

          case 29:
            _context4.prev = 29;
            _context4.t1 = _context4["catch"](11);

            _iterator3.e(_context4.t1);

          case 32:
            _context4.prev = 32;

            _iterator3.f();

            return _context4.finish(32);

          case 35:
            throw new Error("Cannot find project root dir. Underlying errors:\n\n ".concat(errors.join("\n")));

          case 36:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[11, 29, 32, 35], [15, 22]]);
  }));
  return _getPkgJsonDir.apply(this, arguments);
}

function getCacheFilename(_x2) {
  return _getCacheFilename.apply(this, arguments);
}

function _getCacheFilename() {
  _getCacheFilename = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(key) {
    var indexKey, hashData, _key, head, tail, hashPart, crypto, hashFn, hash;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!key.length && key.length <= 0)) {
              _context5.next = 2;
              break;
            }

            throw new Error("Cache key is empty");

          case 2:
            hashData = null;

            if (Array.isArray(key)) {
              _key = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(key), head = _key[0], tail = _key.slice(1);
              indexKey = head;
              hashData = tail;
            } else {
              indexKey = key;
            }

            hashPart = "";

            if (!(hashData && hashData.length > 0)) {
              _context5.next = 12;
              break;
            }

            _context5.next = 8;
            return maybeImport(function () {
              return Promise.all(/* import() */[__webpack_require__.e(8934), __webpack_require__.e(8834), __webpack_require__.e(8421)]).then(__webpack_require__.t.bind(__webpack_require__, 71941, 23));
            });

          case 8:
            crypto = _context5.sent;
            hashFn = crypto === null || crypto === void 0 ? void 0 : crypto.createHash("sha1");
            hash = hashFn === null || hashFn === void 0 ? void 0 : hashFn.update(hashData.map(function (v) {
              return typeof v === "string" ? v : JSON.stringify(v);
            }).join("")).digest("hex");

            if (hash) {
              hashPart = "-".concat(hash);
            }

          case 12:
            return _context5.abrupt("return", "".concat(indexKey).concat(hashPart));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getCacheFilename.apply(this, arguments);
}

function getDefaultCacheDirPath() {
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function _getDefaultCacheDirPath() {
  _getDefaultCacheDirPath = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6() {
    var path;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            path = _context6.sent;
            _context6.t0 = path;
            _context6.next = 6;
            return getPkgJsonDir();

          case 6:
            _context6.t1 = _context6.sent;
            return _context6.abrupt("return", _context6.t0.resolve.call(_context6.t0, _context6.t1, "node_modules/.cache/fsCache"));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function invariantCacheFilePresent(_x3) {
  return _invariantCacheFilePresent.apply(this, arguments);
}

function _invariantCacheFilePresent() {
  _invariantCacheFilePresent = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(cacheFilePath) {
    var _yield$import3, constants, fs;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            _yield$import3 = _context7.sent;
            constants = _yield$import3.constants;
            fs = _yield$import3.promises;
            _context7.next = 7;
            return fs.access(cacheFilePath, constants.F_OK);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _invariantCacheFilePresent.apply(this, arguments);
}

function ensureCacheDirExists(_x4) {
  return _ensureCacheDirExists.apply(this, arguments);
}

function _ensureCacheDirExists() {
  _ensureCacheDirExists = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(cacheDirPath) {
    var _yield$import4, constants, fs;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            _yield$import4 = _context8.sent;
            constants = _yield$import4.constants;
            fs = _yield$import4.promises;
            _context8.prev = 5;
            _context8.next = 8;
            return fs.access(cacheDirPath, constants.F_OK);

          case 8:
            _context8.next = 18;
            break;

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](5);

            if (!(_context8.t0.code === "ENOENT")) {
              _context8.next = 17;
              break;
            }

            _context8.next = 15;
            return fs.mkdir(cacheDirPath, {
              recursive: true
            });

          case 15:
            _context8.next = 18;
            break;

          case 17:
            throw _context8.t0;

          case 18:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[5, 10]]);
  }));
  return _ensureCacheDirExists.apply(this, arguments);
}

function isCacheStale(metadata, staleTime) {
  return metadata.time - Date.now() + staleTime * 1000 < 0;
}

function loadCacheMetadata(_x5) {
  return _loadCacheMetadata.apply(this, arguments);
}

function _loadCacheMetadata() {
  _loadCacheMetadata = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(cacheFilePath) {
    var fs, readline, readable, readInterface, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, line;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            fs = _context9.sent;
            _context9.next = 5;
            return __webpack_require__.e(/* import() */ 6757).then(__webpack_require__.t.bind(__webpack_require__, 16757, 23));

          case 5:
            readline = _context9.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            }); // eslint-disable-next-line no-unreachable-loop

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context9.prev = 10;
            _iterator = _asyncIterator(readInterface);

          case 12:
            _context9.next = 14;
            return _iterator.next();

          case 14:
            if (!(_iteratorAbruptCompletion = !(_step = _context9.sent).done)) {
              _context9.next = 20;
              break;
            }

            line = _step.value;
            return _context9.abrupt("return", JSON.parse(line));

          case 17:
            _iteratorAbruptCompletion = false;
            _context9.next = 12;
            break;

          case 20:
            _context9.next = 26;
            break;

          case 22:
            _context9.prev = 22;
            _context9.t0 = _context9["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context9.t0;

          case 26:
            _context9.prev = 26;
            _context9.prev = 27;

            if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
              _context9.next = 31;
              break;
            }

            _context9.next = 31;
            return _iterator["return"]();

          case 31:
            _context9.prev = 31;

            if (!_didIteratorError) {
              _context9.next = 34;
              break;
            }

            throw _iteratorError;

          case 34:
            return _context9.finish(31);

          case 35:
            return _context9.finish(26);

          case 36:
            throw new Error("Cannot load cache metadata");

          case 37:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[10, 22, 26, 36], [27,, 31, 35]]);
  }));
  return _loadCacheMetadata.apply(this, arguments);
}

function loadCachedData(_x6) {
  return _loadCachedData.apply(this, arguments);
}

function _loadCachedData() {
  _loadCachedData = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(cacheFilePath) {
    var fs, readline, readable, readInterface, data, isFirstLine, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, line;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            fs = _context10.sent;
            _context10.next = 5;
            return __webpack_require__.e(/* import() */ 6757).then(__webpack_require__.t.bind(__webpack_require__, 16757, 23));

          case 5:
            readline = _context10.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            });
            data = "";
            isFirstLine = true;
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context10.prev = 12;
            _iterator2 = _asyncIterator(readInterface);

          case 14:
            _context10.next = 16;
            return _iterator2.next();

          case 16:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context10.sent).done)) {
              _context10.next = 25;
              break;
            }

            line = _step2.value;

            if (!isFirstLine) {
              _context10.next = 21;
              break;
            }

            isFirstLine = false;
            return _context10.abrupt("continue", 22);

          case 21:
            data += line;

          case 22:
            _iteratorAbruptCompletion2 = false;
            _context10.next = 14;
            break;

          case 25:
            _context10.next = 31;
            break;

          case 27:
            _context10.prev = 27;
            _context10.t0 = _context10["catch"](12);
            _didIteratorError2 = true;
            _iteratorError2 = _context10.t0;

          case 31:
            _context10.prev = 31;
            _context10.prev = 32;

            if (!(_iteratorAbruptCompletion2 && _iterator2["return"] != null)) {
              _context10.next = 36;
              break;
            }

            _context10.next = 36;
            return _iterator2["return"]();

          case 36:
            _context10.prev = 36;

            if (!_didIteratorError2) {
              _context10.next = 39;
              break;
            }

            throw _iteratorError2;

          case 39:
            return _context10.finish(36);

          case 40:
            return _context10.finish(31);

          case 41:
            return _context10.abrupt("return", JSON.parse(data));

          case 42:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[12, 27, 31, 41], [32,, 36, 40]]);
  }));
  return _loadCachedData.apply(this, arguments);
}

function isSubDir(_x7, _x8) {
  return _isSubDir.apply(this, arguments);
}
/**
 * Creates a file system cache function proxy. It stores function results in the
 * file system and reuses them as long as they are fresh. Useful to cache heavy
 * network requests while building static page via NextJS. Each function with
 * unique key is stored as a separate entry in a location set via options.
 *
 * @param key - globally unique caching key
 * @param fn - fetching function which returned data will be cached
 * @param opts - options object
 * @returns function proxy with caching layer
 */


function _isSubDir() {
  _isSubDir = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(parent, dir) {
    var path, relative;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            path = _context11.sent;
            relative = path.relative(parent, dir);
            return _context11.abrupt("return", relative && !relative.startsWith("..") && !path.isAbsolute(relative));

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _isSubDir.apply(this, arguments);
}

var createFsCacheProxy = /*#__PURE__*/function () {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(key, fn, _ref) {
    var enabled, _ref$staleTime, staleTime, _ref$cacheDirPath, userCacheDirPath, fsClassic, path, fs, cacheDirPath, cacheFilename, cacheFilePath, targetCacheDirPath;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enabled = _ref.enabled, _ref$staleTime = _ref.staleTime, staleTime = _ref$staleTime === void 0 ? 300 : _ref$staleTime, _ref$cacheDirPath = _ref.cacheDirPath, userCacheDirPath = _ref$cacheDirPath === void 0 ? "/workdir/apps/segment/node_modules/.cache/fsCache" : _ref$cacheDirPath;
            _context2.next = 3;
            return maybeImport(function () {
              return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));
            });

          case 3:
            fsClassic = _context2.sent;
            _context2.next = 6;
            return maybeImport(function () {
              return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));
            });

          case 6:
            path = _context2.sent;

            if (!(!fsClassic || !path || !enabled || true)) {}

            return _context2.abrupt("return", fn);

          case 9:
            fs = fsClassic.promises;
            _context2.t0 = path;

            if (!(userCacheDirPath !== null && userCacheDirPath !== void 0)) {
              _context2.next = 15;
              break;
            }

            _context2.t1 = userCacheDirPath;
            _context2.next = 18;
            break;

          case 15:
            _context2.next = 17;
            return getDefaultCacheDirPath();

          case 17:
            _context2.t1 = _context2.sent;

          case 18:
            _context2.t2 = _context2.t1;
            cacheDirPath = _context2.t0.resolve.call(_context2.t0, _context2.t2);
            _context2.next = 22;
            return getCacheFilename(key);

          case 22:
            cacheFilename = _context2.sent;
            cacheFilePath = path.resolve(cacheDirPath, cacheFilename);
            targetCacheDirPath = path.dirname(cacheFilePath);
            _context2.t3 = cacheDirPath !== targetCacheDirPath;

            if (!_context2.t3) {
              _context2.next = 30;
              break;
            }

            _context2.next = 29;
            return isSubDir(cacheDirPath, targetCacheDirPath);

          case 29:
            _context2.t3 = !_context2.sent;

          case 30:
            if (!_context2.t3) {
              _context2.next = 32;
              break;
            }

            throw new Error("Cache file tries to jailbreak cache dir. Make sure that cache key doesn't start with eg. \"../\".");

          case 32:
            return _context2.abrupt("return", new Proxy(fn, {
              apply: function apply(target, _that, args) {
                return (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                  var metadata, isCacheStaleValue, result, newCacheMetadata, stringifiedMetadata, dataToCache, cachePayload;
                  return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return invariantCacheFilePresent(cacheFilePath);

                        case 3:
                          _context.next = 5;
                          return loadCacheMetadata(cacheFilePath);

                        case 5:
                          metadata = _context.sent;
                          _context.next = 8;
                          return isCacheStale(metadata, staleTime);

                        case 8:
                          isCacheStaleValue = _context.sent;

                          if (isCacheStaleValue) {
                            _context.next = 11;
                            break;
                          }

                          return _context.abrupt("return", loadCachedData(cacheFilePath));

                        case 11:
                          _context.next = 15;
                          break;

                        case 13:
                          _context.prev = 13;
                          _context.t0 = _context["catch"](0);

                        case 15:
                          _context.next = 17;
                          return target.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));

                        case 17:
                          result = _context.sent;
                          newCacheMetadata = {
                            time: Date.now()
                          };
                          stringifiedMetadata = JSON.stringify(newCacheMetadata);
                          _context.prev = 20;
                          dataToCache = JSON.stringify(result);
                          _context.next = 27;
                          break;

                        case 24:
                          _context.prev = 24;
                          _context.t1 = _context["catch"](20);
                          throw new Error("Failed to JSON stringify result. Caching only supported for simple data.\n\n Inner exception: \n".concat(dataToCache));

                        case 27:
                          cachePayload = stringifiedMetadata + "\n" + dataToCache;
                          _context.next = 30;
                          return ensureCacheDirExists(targetCacheDirPath);

                        case 30:
                          _context.next = 32;
                          return fs.writeFile(cacheFilePath, cachePayload, {
                            encoding: "utf8"
                          });

                        case 32:
                          return _context.abrupt("return", result);

                        case 33:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 13], [20, 24]]);
                }))();
              }
            }));

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createFsCacheProxy(_x9, _x10, _x11) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 96904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* reexport safe */ _fsCache__WEBPACK_IMPORTED_MODULE_0__.c; }
/* harmony export */ });
/* harmony import */ var _fsCache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10715);


/***/ }),

/***/ 54546:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/integrations/[[...slug]]",
      function () {
        return __webpack_require__(79254);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64011:
/***/ (function(module) {

module.exports = "/_next/static/images/OgCatalog-dc0f7c2b805a516d6a707c1c0572b09f.png";

/***/ }),

/***/ 58586:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(36370);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(91578);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(54388);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 4 modules
var useBaseQuery = __webpack_require__(53997);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ }),

/***/ 95922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64034);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17602);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57211);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42330);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8943,1970,1382,4136,2073,8392,5735,2429,7303,4488,948,8187,3996,7947,7960,6012,442,3379,9550,4904,9774,2888,179], function() { return __webpack_exec__(54546); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);